export default function SignupScreen() {
  return null;
}